import AdminClasses from "./admin/AllClasses";
import Layout from "../../components/Layout";
import { useUserState } from "../../context/UserContext";
import Permission from "../error/Permission";

const Profile = () => {
  const { userRole } = useUserState();

  return (
    <Layout children={
      <>
        {userRole?.role === "school_admin" ? (
          <AdminClasses />
        ) : <Permission />}
      </>
    }
    />
  );
};

export default Profile;
